// extracted by mini-css-extract-plugin
export default {"root":"CardNumber__root--2My4p","dot":"CardNumber__dot--oNejV","dots":"CardNumber__dots--2I468"};